function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDomesticMapRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6h5V4h-5v2zm5-4h-5a2 2 0 00-2 2v4h9V4a2 2 0 00-2-2zM23 12h5v16h-3v-8H15v-2h8v-6zm-2 4h-8v6h10v8h5a2 2 0 002-2V10h-9v6z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 28h4v-2h-4v2zm-2 0a2 2 0 002 2h6v-6h-8v4zM9 28H7v-7H4v-3h5v10zM2 16v5a2 2 0 002 2h1v5a2 2 0 002 2h2a2 2 0 002-2V16H2zM4 6h2V4H4v2zm4-2a2 2 0 00-2-2H4a2 2 0 00-2 2v4h6V4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10H2v2h10V2h-2v8z",
    fill: props.color
  }));
}

export default SvgIconDomesticMapRexOutline;